import { Button, Col, DatePicker, Form, Modal, Row, Typography } from "antd";
import BieuDo from "components/bieuDo";
import FillterTable from "components/FillterTable";
import { PopUpAddGraphical } from "components/popupAddGraphical";
import RenderForm from "components/renderForm";
import TablePagination from "components/TablePagination";
import dayjs from "dayjs";
import { exportTableToExcelNew } from "helpers";
import { ConverData, ConverDataName } from "helpers/dataToAntdSelect";
import { rangePresets } from "helpers/helpersDatePicker";
import { useEffect, useMemo, useState } from "react";
import { useQueries } from "react-query";
import { getGoodDaySelectionWorkList, getTemplateIds, responseMessages } from "services/apiRequest";
import { getDataZalo, getGraphicalZalo } from "services/thongKeZaloRequest";

export default function ThongKeZalo() {

    const metricId = 12;
    const dimensionId = 12;

    const [form] = Form.useForm();

    const [tableFields, setTableFields] = useState({ metricIds: [1, 2], dimensionIds: [1] });

    const [
        { data: dataResponseMessage },
        { data: dataTemplateIds }
    ] = useQueries([
        {
            queryKey: ["dataResponseMessage"],
            queryFn: () => responseMessages(),
        },
        {
            queryKey: ["dataTemplateIds"],
            queryFn: () => getTemplateIds(),
        },
    ]);
    const [dataExport, setDataExport] = useState(null);

    const [graphical, setGraphical] = useState(null);

    const setUpFormModal = [
        {
            name: 'range-time',
            type: 'range-picker',
            lg: 6,
            propsInput: {
                format: "DD/MM/YYYY",
                presets: rangePresets
                // showSearch: true,
                // allowClear: true
            },
            label: 'Khoảng thời gian',
        },
        {
            name: 'templateIds',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Mẫu',
            options: ConverData(dataTemplateIds?.data || []),
        },
        {
            name: 'responseMessages',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Thông báo trả về',
            options: ConverDataName(dataResponseMessage?.data || []),
        },
        {
            type: "html",
            lg: 3,
            content: (
                <Row className={"flex justify-start items-end content-end h-full"}>
                    <Button type="primary"
                        onClick={() => {
                            form.submit();
                        }}
                    >Áp dụng</Button>
                </Row>
            ),
        },
    ];

    const [whereCondition, setWhereCondition] = useState({
        startTime: dayjs().subtract(30, 'days').format("DD/MM/YYYY"),
        endTime: dayjs().format("DD/MM/YYYY"),
        templateIds: [],
        responseMessages: [],
    });

    useEffect(() => {

        let initialValues = Object.assign({}, whereCondition);

        const startTime = dayjs(initialValues.startTime, 'DD/MM/YYYY').isValid() ? dayjs(initialValues.startTime, 'DD/MM/YYYY') : null;
        const endTime = dayjs(initialValues.endTime, 'DD/MM/YYYY').isValid() ? dayjs(initialValues.endTime, 'DD/MM/YYYY') : null;

        initialValues['range-time'] = [startTime, endTime];

        form.setFieldsValue(initialValues);
    }, []);

    return (
        <div className="px-7">
            <div className="flex flex-col gap-5 p-7 card">
                <div className="flex items-center justify-items-center justify-between">
                    <h1>
                        <b>THỐNG KÊ ZALO</b>
                    </h1>

                    <div className="flex justify-content-end gap-3">
                        <Button
                            type="primary"
                            onClick={() => {
                                exportTableToExcelNew(dataExport, "THONG_KE_ZALO");
                            }}
                        >
                            Export
                        </Button>
                        <PopUpAddGraphical
                            metricId={metricId}
                            dimensionId={dimensionId}
                            addDataFields={values => {
                                const newValues = { ...values };
                                setGraphical(newValues);
                            }}
                        />
                    </div>
                </div>

                <RenderForm
                    onFinish={(values) => {
                        let dataQueries = Object.assign({}, whereCondition);

                        Object.keys(values).map(key => {
                            const item = values[key];
                            if (key == "range-time") {

                                const startTime = dayjs(item[0]).format('DD/MM/YYYY');
                                const endTime = dayjs(item[1]).format('DD/MM/YYYY');

                                dataQueries.startTime = startTime;
                                dataQueries.endTime = endTime;
                            } else {
                                if (item) {
                                    dataQueries[key] = item;
                                } else {
                                    dataQueries[key] = [];
                                }
                            }
                        })
                        setWhereCondition(dataQueries);
                    }}
                    form={form}
                    fields={setUpFormModal}
                    footer={<></>}
                />

                <BieuDo
                    metricId={metricId}
                    dimensionId={dimensionId}
                    whereCondition={whereCondition}
                    apiCallBack={getGraphicalZalo}
                    dataFields={[{ metricIds: [1], dimensionIds: [null] }]}
                    addGraphical={graphical}
                />

                <div className="flex w-full">
                    <Row className="w-full" justify="space-between" gutter={[10, 10]}>
                        <Col span={20}>
                            <TablePagination
                                apiCallBack={getDataZalo}
                                whereCondition={whereCondition}
                                dataFields={tableFields}
                                dataTableChange={values => {
                                    setDataExport(values);
                                }}
                            />
                        </Col>
                        <Col span={4}>
                            <FillterTable
                                metricId={metricId}
                                dimensionId={dimensionId}
                                dataFields={tableFields}
                                onFieldsChange={values => {
                                    setTableFields(values);
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}